import type { SolarProposalImpactSectionDto } from "~/api/dto/solar-proposal-impact.dto"

import { SectionNotice } from "./SectionNotice"
import { Environment } from "./sections/story"
import type { SolarSectionState } from "./solar-presentation-data"
import { toSolarImpact } from "./solar-proposal-impact"

/**
 * The environmental impact section. The impact read loads and fails on its
 * own, so every other section stays rendered whatever happens here. A proposal
 * with no figure to show has no section at all.
 */
export const SolarImpactSection = ({
  state,
}: {
  state: SolarSectionState<SolarProposalImpactSectionDto>
}): JSX.Element | null => {
  if (state.status !== `ready`) {
    return (
      <SectionNotice
        id="environment"
        state={state}
        noun="the environmental impact"
      />
    )
  }

  const impact = state.data.impact && toSolarImpact(state.data.impact)

  return impact && impact.stats.length > 0 ? (
    <Environment impact={impact} />
  ) : null
}
